module.exports = __webpack_public_path__ + "img/global-1992-australia.ee4847d4.jpg";